import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

const TablePagination = ({
  currentPage,
  setCurrentPage,
  rowsPerPage,
  totalRows,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const start = (currentPage - 1) * rowsPerPage + 1;
  const end = Math.min(currentPage * rowsPerPage, totalRows);

  return (
    <Row className="justify-content-between align-items-center px-3 py-2 mt-3 border rounded bg-light flex-wrap">
      <Col xs="auto" className="mb-2 mb-md-0">
        <small className="text-muted">
          {start}-{end} of {totalRows}
        </small>
      </Col>
      <Col xs="auto" className="d-flex align-items-center flex-wrap gap-2">
        <button
          className="btn btn-sm btn-light"
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
        >
          <FiArrowLeft />
        </button>
        <span className="mx-1 text-muted">
          {currentPage}/{totalPages}
        </span>
        <button
          className="btn btn-sm btn-light"
          onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          <FiArrowRight />
        </button>
      </Col>
    </Row>
  );
};

export default TablePagination;
